import { render, staticRenderFns } from "./GlobalStyles.vue?vue&type=template&id=982f4afe"
import script from "./GlobalStyles.vue?vue&type=script&lang=js"
export * from "./GlobalStyles.vue?vue&type=script&lang=js"
import style0 from "./GlobalStyles.vue?vue&type=style&index=0&id=982f4afe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports